export enum LessonLearntBestPractice {
  LESSON_LEARNT = "LESSON_LEARNT",
  BEST_PRACTICE = "BEST_PRACTICE"
}

export const lessonLearntBestPracticeToLabel = {
  [LessonLearntBestPractice.LESSON_LEARNT]: "Lesson Learnt",
  [LessonLearntBestPractice.BEST_PRACTICE]: "Best Practice"
}
